<template>
  <div class="brand" data-aos="fade-down" data-aos-duration="1000">
    <div class="brand-row container">
      <MyTitle>
        <template v-slot:title>连续<i> {{ new Date().getFullYear() - 2014 }} </i>年专注水电站领域</template>
        <template v-slot:subtitle>
          用科学原理和理性逻辑诠释她的深层技术，
          让生态的绿色和财富的金色永远与她相伴
        </template>
      </MyTitle>
      <div class="brand-slogan">
        <ul>
          <li v-for="(item,index) in brandList" :key="item.id" data-aos="fade-left" :data-aos-duration="index * 1000">
            <div class="brand-slogan-top">
              <div class="slot-img">
                <el-image :src="item.image_url" lazy></el-image>
              </div>
              <img src="@/assets/images/outer-frame.png" alt="outer-frame">
            </div>
            <p class="slogan-title">{{ item.title }}</p>
            <p>{{ item.description }}</p>
          </li>
        </ul>
        <el-empty :image-size="200" v-if="brandList.length === 0"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Brand",
  data() {
    return {
      brandList: []
    }
  },
  methods: {
    async getBrandList() {
      let results = await this.$api.reqBrandList()

      if (results.status === 200) {
        this.brandList = results.results
      } else {
        this.$message({showClose: true, message: "品牌数据请求失败！", type: "error"})
      }
    },
  },

  mounted() {
    this.getBrandList()
  }
}
</script>

<style scoped lang="less">
.brand {
  height: 463px;
  margin: 50px 0 90px 0;

  .brand-row {

    .brand-slogan {

      ul {
        display: flex;
        justify-content: space-between;
        text-align: center;
        margin-top: 25px;

        li {
          width: 224px;

          .slogan-title {
            margin-bottom: 15px;
            color: rgb(53, 53, 53);
            font-size: 18px;
          }

          p {
            font-size: 14px;
            line-height: 20px;
            color: rgb(103, 103, 103);
          }

          .brand-slogan-top {
            position: relative;
            width: 224px;
            height: 224px;

            .slot-img {
              position: absolute;
              top: 29px;
              left: 32px;
              border-radius: 50%;
              width: 160px;
              height: 160px;
              overflow: hidden;

              .el-image {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }

  /deep/ .el-skeleton__paragraph {
    margin-top: 7px;
  }
}
</style>